import Image from 'next/image';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { scrollToContactUs } from '../../../shared/useCommon';
import { ExpertTipStyle } from '../../../styles/components/common/blocks';
import { Button } from '../ui';

export interface IExpertTipProps {
  title: string;
  content: string;
  primaryButton: {
    label: string;
  };
  secondaryButton?: {
    label?: string;
    path?: string;
  };
}

const ExpertTip = (props: IExpertTipProps) => {
  const router = useRouter();

  return (
    <div className={ExpertTipStyle['expert-tip']}>
      <div className={ExpertTipStyle['expert-tip-heading']}>
        <Image
          quality={90}
          src="/assets/images/icons/TipIcon.svg"
          alt={props.title}
          width={40}
          height={40}
        />
        <h2>{props.title}</h2>
      </div>

      <div className={ExpertTipStyle['expert-tip-content']}>
        <ReactMarkdown>{props.content}</ReactMarkdown>
      </div>

      <div className={ExpertTipStyle['expert-tip-footer']}>
        <Button
          color="cta"
          onClick={() => {
            scrollToContactUs();
          }}>
          {props.primaryButton.label}
        </Button>
        {!!props.secondaryButton &&
          !!props.secondaryButton.label &&
          !!props.secondaryButton.path && (
            <Button
              color="cta-outline"
              onClick={() => {
                router.push(props.secondaryButton!.path!);
              }}>
              {props.secondaryButton.label}
            </Button>
          )}
      </div>
    </div>
  );
};

export default ExpertTip;
